module.exports = __webpack_public_path__ + "img/icons-20-filter.1526bb60.svg";